import React, { useEffect } from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiStar } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import Flex from 'typescript-styled-flex'
import { useSelector } from 'react-redux'
import {
  ButtonLabel,
  Label,
  PremiumButton,
  PremiumWrapper,
} from '../../../../../components/Template/Premium'
import { ILicense } from '../../../../../models/License'
import getDays from '../../../../../utils/License/getDays'
import getFinalValidLicenses from '../../../../../utils/License/getFinalValidLicenses'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import PromoStart from '../../../../../assets/promotion/p50v2.gif'
import { getAccessToken } from '../../../../../reducers/userAccount/selectors/credentials'
import PremiumLicenses, { mapLicenseToName } from './PremiumLicenses'
import {
  getUserId,
  getUserLanguage,
  getUserPremiumUsed,
  isUserNewPackage,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getPanelUrlForEnv } from '../../../../../utils/ApiUrl'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import { isEmpty } from 'lodash'
import Error from '../../../../../assets/icons/error2.svg'
import { getActiveLicense } from '../../../../../reducers/userAccount/selectors/license'

function Premium({
  licenses,
  validLicenses,
  t,
  isAuthorizing,
  isLicenseValid,
  size = 1,
}: IPremiumProps & WithTranslation & IWithSize) {
  const [show, setShow] = React.useState(false)
  const anchor: React.MutableRefObject<HTMLDivElement> = React.useRef()
  const userId = useSelector(getUserId)
  const key = useSelector(getAccessToken)
  const finalLicenses = getFinalValidLicenses(validLicenses)

  const licenseType = useSelector(getActiveLicense)
  const days = getDays(finalLicenses.active)
  const newPremium = useSelector(isUserNewPackage)

  const subError = Object.values(finalLicenses).some(l => {
    return l.some(license => {
      if (isEmpty(license.sub)) return false
      return license.sub.status_extended === 'PAYMENT_ERROR'
    })
  })

  const isSub = Object.values(finalLicenses).some(l => {
    return l.some(license => {
      if (isEmpty(license.sub)) return false
      return (
        license.sub.status_extended === 'ACTIVE' ||
        license.sub.status_extended === 'WAITING'
      )
    })
  })

  let canClose = true
  let showTimeout

  const scopes = useIsScope({
    premium: [PermissionScope.SCOPE_CAN_BUY_PREMIUM],
  })

  useEffect(() => {
    if (show) {
      Mixpanel.people.increment(userId, 'Premium Active Screen Viewed', 1)
      Mixpanel.track('Premium Active Screen View', {
        'Premium Days Remaining': Number(days),
      })
    }
  }, [show, days, userId])

  function toggleShow() {
    if (!canClose) {
      canClose = true
    } else {
      showTimeout = setTimeout(() => setShow(true), 75)
    }
  }

  function closeShow() {
    setTimeout(() => {
      if (!canClose) {
        clearTimeout(showTimeout)
        setShow(false)
      }
    }, 1)
  }

  function setShouldClose() {
    if (show) {
      canClose = false
    }
  }

  /*function disablePropagation(e: React.MouseEvent) {
    e.stopPropagation()
  }*/

  function shouldClose() {
    setTimeout(() => {
      if (canClose) {
        clearTimeout(showTimeout)
        setShow(false)
      }
    }, 1)
  }

  function goToPremium2() {
    Mixpanel.people.increment(userId, 'Premium Menu Opened', 1)
    Mixpanel.track('Main Menu Premium Item Used', {})
    //var EnvUrl = getApiUrlForEnv()
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
  }

  function goToPremium() {
    if (isSub) {
      ;(window as any).routerHistory.push('/premium', {})
    } else {
      Mixpanel.track('Premium Active Screen Extend Access', {})
      //var EnvUrl = getApiUrlForEnv()
      window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
    }
  }

  function goToPremiumPromo() {
    //var EnvUrl = getApiUrlForEnv()
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment/index/months/1/services/1/sale_tag/OTWIERAMYPREZENT_web_headline_icon`
  }

  const start = 1620432000
  //const start = 1574640000
  const today = Math.floor(Date.now() / 1000)
  const end = 1621123199
  let language = useSelector(getUserLanguage)
  let showPromotion =
    today > start && today < end && (language === 'pl' || language === 'pl_PL')

  const promotionUsed = Number(useSelector(getUserPremiumUsed))
  if (promotionUsed === 1) {
    showPromotion = false
  }

  return (
    <React.Fragment>
      {!isAuthorizing && (
        <React.Fragment>
          {showPromotion && (
            <img
              src={PromoStart}
              onClick={goToPremiumPromo}
              alt="promotion"
              style={{ cursor: 'pointer', height: '24px', marginTop: '10px' }}
            />
          )}
          {isLicenseValid && (
            <PremiumWrapper
              size={size}
              alignCenter={true}
              show={show}
              onMouseEnter={toggleShow}
              onMouseLeave={shouldClose}
              ref={anchor}
            >
              {subError ? (
                <img
                  style={{
                    marginLeft: `${15 * size}px`,
                    marginRight: `${10 * size}px`,
                  }}
                  alt={'icon'}
                  src={Error}
                />
              ) : (
                <FiStar
                  size={19 * size}
                  style={{
                    marginLeft: `${15 * size}px`,
                    marginRight: `${10 * size}px`,
                  }}
                />
              )}
              <Label size={size} fw={500}>
                {newPremium && isSub ? (
                  <>
                    {t(mapLicenseToName(licenseType, t, newPremium))}:{' '}
                    {isLicenseValid ?  t('BED_8482_active') : ''}
                  </>
                ) : (
                  <>
                    <Trans i18nKey={'menu_upgrade'}>Premium</Trans> :{' '}
                    <b style={{ pointerEvents: 'none' }}>
                      {!isSub ? (
                        <>
                          {days} {t(days === 1 ? 'days_count_day' : 'days')}
                        </>
                      ) : (
                        <>
                          {subError
                            ? t('BED_26058_payment_issue')
                            : t('BKO_773_DefaultTaxRateActive').toLowerCase()}
                        </>
                      )}
                    </b>
                  </>
                )}
              </Label>
              {/*{newPremium && isSub && <div style={{ width: '30px' }}></div>}*/}
              {scopes.premium && !isSub && (
                <PremiumButton
                  size={size}
                  as={Link}
                  onClick={goToPremium}
                  {...{ to: '#' }}
                  white={true}
                >
                  <ButtonLabel size={size}>{t('prolong_access')}</ButtonLabel>
                </PremiumButton>
              )}
            </PremiumWrapper>
          )}
          {!isLicenseValid && scopes.premium && (
            <Flex alignCenter={true}>
              <PremiumButton
                size={size}
                as={Link}
                white={true}
                onClick={goToPremium2}
              >
                <ButtonLabel size={size}>
                  {t('info_slider_bay_premium')}
                </ButtonLabel>
              </PremiumButton>
            </Flex>
          )}
          {anchor.current && (
            <PremiumLicenses
              size={size}
              show={show}
              close={closeShow}
              setCanClose={setShouldClose}
              anchor={anchor}
              validLicenses={validLicenses}
              licenses={licenses}
              newPremium={newPremium}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default Premium

export interface IPremiumProps {
  licenses: ILicense[]
  validLicenses: ILicense[]
  isAuthorizing?: boolean
  isLicenseValid?: boolean
}
